export var FilterSymbol;
(function (FilterSymbol) {
    FilterSymbol["=="] = "==";
    FilterSymbol["("] = "(";
    FilterSymbol[")"] = ")";
    FilterSymbol["like"] = "like";
    FilterSymbol["<"] = "<";
    FilterSymbol[">"] = ">";
    FilterSymbol["<="] = "<=";
    FilterSymbol["!="] = "!=";
    FilterSymbol[">="] = ">=";
    FilterSymbol["+"] = "+";
    FilterSymbol["-"] = "-";
    FilterSymbol[","] = ",";
    FilterSymbol["or"] = "or";
    FilterSymbol["*"] = "*";
    FilterSymbol["/"] = "/";
    FilterSymbol["%"] = "%";
    FilterSymbol["."] = ".";
    FilterSymbol["and"] = "and";
    FilterSymbol["^"] = "^";
})(FilterSymbol || (FilterSymbol = {}));
export var TimeMathOperator;
(function (TimeMathOperator) {
    TimeMathOperator["+"] = "+";
    TimeMathOperator["-"] = "-";
})(TimeMathOperator || (TimeMathOperator = {}));
export var NumericMathOperator;
(function (NumericMathOperator) {
    NumericMathOperator["+"] = "+";
    NumericMathOperator["-"] = "-";
    NumericMathOperator["*"] = "*";
    NumericMathOperator["/"] = "/";
    NumericMathOperator["%"] = "%";
    NumericMathOperator["^"] = "^";
})(NumericMathOperator || (NumericMathOperator = {}));
export var LookupOperator;
(function (LookupOperator) {
    LookupOperator["."] = ".";
})(LookupOperator || (LookupOperator = {}));
export var BinaryLogicalOperator;
(function (BinaryLogicalOperator) {
    BinaryLogicalOperator["or"] = "or";
    BinaryLogicalOperator["and"] = "and";
})(BinaryLogicalOperator || (BinaryLogicalOperator = {}));
export var NumericComparisonOperator;
(function (NumericComparisonOperator) {
    NumericComparisonOperator["=="] = "==";
    NumericComparisonOperator["!="] = "!=";
    NumericComparisonOperator["<"] = "<";
    NumericComparisonOperator["<="] = "<=";
    NumericComparisonOperator[">"] = ">";
    NumericComparisonOperator[">="] = ">=";
})(NumericComparisonOperator || (NumericComparisonOperator = {}));
export var TimeComparisonOperator;
(function (TimeComparisonOperator) {
    TimeComparisonOperator["<"] = "<";
    TimeComparisonOperator[">"] = ">";
})(TimeComparisonOperator || (TimeComparisonOperator = {}));
export var EnumComparisonOperator;
(function (EnumComparisonOperator) {
    EnumComparisonOperator["=="] = "==";
    EnumComparisonOperator["!="] = "!=";
})(EnumComparisonOperator || (EnumComparisonOperator = {}));
export var GroupingSymbol;
(function (GroupingSymbol) {
    GroupingSymbol["("] = "(";
    GroupingSymbol[")"] = ")";
})(GroupingSymbol || (GroupingSymbol = {}));
export var StringComparisonOperator;
(function (StringComparisonOperator) {
    StringComparisonOperator["like"] = "like";
    StringComparisonOperator["=="] = "==";
    StringComparisonOperator["!="] = "!=";
    StringComparisonOperator["<"] = "<";
    StringComparisonOperator["<="] = "<=";
    StringComparisonOperator[">"] = ">";
    StringComparisonOperator[">="] = ">=";
})(StringComparisonOperator || (StringComparisonOperator = {}));
export var StringOperationOperator;
(function (StringOperationOperator) {
    StringOperationOperator["+"] = "+";
})(StringOperationOperator || (StringOperationOperator = {}));
export var UnaryOperator;
(function (UnaryOperator) {
    UnaryOperator["-"] = "-";
    UnaryOperator["+"] = "+";
})(UnaryOperator || (UnaryOperator = {}));
export var OperatorType;
(function (OperatorType) {
    OperatorType["logical"] = "logical";
    OperatorType["comparison"] = "comparison";
    OperatorType["math"] = "math";
    OperatorType["unknown"] = "unknown";
})(OperatorType || (OperatorType = {}));
export const isParameterTyped = (dt) => typeof dt === 'object' && 'index' in dt;
export const isSeriesTyped = (dt) => typeof dt === 'object' && 'series' in dt;
export const isFieldTyped = (dt) => typeof dt === 'string' || (typeof dt === 'object' && 'type' in dt);
export var TokenType;
(function (TokenType) {
    TokenType["Error"] = "error";
    TokenType["Symbol"] = "symbol";
    TokenType["String"] = "string";
    TokenType["Regex"] = "regex";
    TokenType["Name"] = "name";
    TokenType["Number"] = "number";
    TokenType["Whitespace"] = "ws";
})(TokenType || (TokenType = {}));
export var FieldTypeCategory;
(function (FieldTypeCategory) {
    FieldTypeCategory["Double"] = "double";
    FieldTypeCategory["Integer"] = "int";
    FieldTypeCategory["String"] = "string";
    FieldTypeCategory["Timestamp"] = "timestamp";
    FieldTypeCategory["Enum"] = "enum";
    FieldTypeCategory["Bitmask"] = "bitmask";
    FieldTypeCategory["Boolean"] = "boolean";
    FieldTypeCategory["Index"] = "index";
    FieldTypeCategory["Regex"] = "regex";
    FieldTypeCategory["Timeframe"] = "timeframe";
    FieldTypeCategory["Periodicity"] = "periodicity";
    FieldTypeCategory["PointInTime"] = "pointInTime";
    FieldTypeCategory["Duration"] = "duration";
    FieldTypeCategory["Ignored"] = "ignored";
})(FieldTypeCategory || (FieldTypeCategory = {}));
export var NumericUnit;
(function (NumericUnit) {
    NumericUnit["percent"] = "percent";
    NumericUnit["volume"] = "volume";
    NumericUnit["price"] = "price";
    NumericUnit["rank"] = "rank";
    NumericUnit["quantity"] = "quantity";
})(NumericUnit || (NumericUnit = {}));
export var StringUnit;
(function (StringUnit) {
    StringUnit["symbol"] = "symbol";
    StringUnit["name"] = "name";
    StringUnit["account"] = "account";
    StringUnit["position"] = "position";
})(StringUnit || (StringUnit = {}));
//# sourceMappingURL=language.js.map